import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs';
import { FMessageDialogService } from 'src/app/feature-module/components/f-message-dialog/f-message-dialog-service/f-message-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class HttpProviderService {
  private providerPath = environment.hostURL;

  constructor(
    private http: HttpClient,
    private _msg: FMessageDialogService,
  ) { }

  sendGetRequest(path: string, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      params: params,
      observe: "response" as 'body',
    };
    return this.http.get(`${this.providerPath}${path}`, requestOptions).pipe(
      tap(response => {
        const status: number | undefined | null = (response as HttpResponse<any>).body?.status ?? (response as HttpResponse<any>).body?.result?.status ?? undefined;
        if ((status != null || status != undefined) && status <= 0) throw response;
      }),
      catchError(err => {
        if (((err.error?.message ?? '') as string).includes('Payroll Category')) throw err;

        this._msg.open({
          title: 'Server Error',
          message: [
            'Error Message: ',
            err?.error?.message ?? err?.body?.message ?? err?.body?.result?.message ?? 'A server error has occurred. Please try again later.',,
          ],
          type: 'danger'
        }, true);
        throw err;
      })
    );
  }

  sendPostRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    return this.http.post(`${this.providerPath}${path}`, body, requestOptions).pipe(
      tap(response => {
        const status: number | undefined | null = (response as HttpResponse<any>).body?.status ?? (response as HttpResponse<any>).body?.result?.status ?? undefined;
        if ((status != null || status != undefined) && status <= 0) throw response;
      }),
      catchError(err => {
        this._msg.open({
          title: 'Server Error',
          message: [
            'Error Message: ',
            err?.error?.message ?? err?.body?.message ?? err?.body?.result?.message ?? 'A server error has occurred. Please try again later.',,
          ],
          type: 'danger'
        }, true);
        throw err;
      })
    );
  }

  sendPatchRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    return this.http.patch(`${this.providerPath}${path}`, body, requestOptions).pipe(
      tap(response => {
        const status: number | undefined | null = (response as HttpResponse<any>).body?.status ?? (response as HttpResponse<any>).body?.result?.status ?? undefined;
        if ((status != null || status != undefined) && status <= 0) throw response;
      }),
      catchError(err => {
        this._msg.open({
          title: 'Server Error',
          message: [
            'Error Message: ',
            err?.error?.message ?? err?.body?.message ?? err?.body?.result?.message ?? 'A server error has occurred. Please try again later.',,
          ],
          type: 'danger'
        }, true);
        throw err;
      })
    );
  }

  sendPutRequest(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    return this.http.put(`${this.providerPath}${path}`, body, requestOptions).pipe(
      tap(response => {
        const status: number | undefined | null = (response as HttpResponse<any>).body?.status ?? (response as HttpResponse<any>).body?.result?.status ?? undefined;
        if ((status != null || status != undefined) && status <= 0) throw response;
      }),
      catchError(err => {
        this._msg.open({
          title: 'Server Error',
          message: [
            'Error Message: ',
            err?.error?.message ?? err?.body?.message ?? err?.body?.result?.message ?? 'A server error has occurred. Please try again later.',,
          ],
          type: 'danger'
        }, true);
        throw err;
      })
    );
  }

  sendDeleteRequest(path: string, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    return this.http.delete(`${this.providerPath}${path}`, requestOptions).pipe(
      tap(response => {
        const status: number | undefined | null = (response as HttpResponse<any>).body?.status ?? (response as HttpResponse<any>).body?.result?.status ?? undefined;
        if ((status != null || status != undefined) && status <= 0) throw response;
      }),
      catchError(err => {
        this._msg.open({
          title: 'Server Error',
          message: [
            'Error Message: ',
            err?.error?.message ?? err?.body?.message ?? err?.body?.result?.message ?? 'A server error has occurred. Please try again later.',,
          ],
          type: 'danger'
        }, true);
        throw err;
      })
    );
  }

  sendPutRequest_Raw(path: string, body: any, headers: HttpHeaders, params: HttpParams) {
    const requestOptions = {
      headers: headers,
      observe: "response" as 'body',
      params: params
    };
    return this.http.put(path, body, requestOptions).pipe(
      tap(response => {
        const status: number | undefined | null = (response as HttpResponse<any>).body?.status ?? (response as HttpResponse<any>).body?.result?.status ?? undefined;
        if ((status != null || status != undefined) && status <= 0) throw response;
      }),
      catchError(err => {
        this._msg.open({
          title: 'Server Error',
          message: [
            'Error Message: ',
            err?.error?.message ?? err?.body?.message ?? err?.body?.result?.message ?? 'A server error has occurred. Please try again later.',,
          ],
          type: 'danger'
        }, true);
        throw err;
      })
    );
  }

}

//provider service pattern

// @Injectable({
//   providedIn: 'root'
// })
// export class MemberProviderService extends HttpProviderService {
//   constructor(
//     private providerHttp: HttpClient,
//     private _msg: FMessageDialogService,
//   ) {
//     super(providerHttp, "", _msg);
//   }
// }


// //add endpoints here
// //can be multiple(microservice pattern)
// @Injectable({
//   providedIn: 'root'
// })
// export class HHTProviderService extends HttpProviderService {
//   constructor(
//     private providerHttp: HttpClient,
//     private _msg: FMessageDialogService,
//   ) {
//     super(providerHttp, environment.hostURL, _msg);
//   }
// }